import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { usePopper } from "react-popper";
import { bottom, top, left, right } from "@popperjs/core";
import { classNames } from "../../helpers/classNames";

const Dropdown = ({ data = [], label, labelClasses, buttonClasses, buttonLabelClasses, buttonIcon, buttonIconPosition, buttonLabel, dropdownContainer, xPlacement = "left", buttonArrowIconClasses, buttonArrowIcon = "fa-regular fa-chevron-down", button, showTransition = true, onChange = () => { } }) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const placements = {
    bottom: bottom,
    bottomLeft: "bottom-start",
    bottomRight: "bottom-end",
    top: top,
    topLeft: "top-start",
    topRight: "top-end",
    right: right,
    left: left,
    "": bottom,
  };

  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement || ""],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 0],
        },
      },
    ],
  });

  useEffect(() => {
    const originalOverflow = document.documentElement.style.overflow;
    const originalPadding = document.documentElement.style.paddingRight;

    const observer = new MutationObserver(() => {
      if (document.documentElement.style.overflow === "hidden") {
        document.documentElement.style.overflow = originalOverflow;
        document.documentElement.style.paddingRight = originalPadding;
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Menu as="div" className="relative w-full">
        <div className="relative space-y-1 w-full">
          {label && <div className={classNames("text-sm font-semibold text-opplio-gray tracking-none font-Poppins", labelClasses)}>{label}</div>}
          <div className="relative w-full">
            <MenuButton ref={setTargetElement} className={classNames("flex items-center justify-center space-x-2 h-10 border border-md-pink-light-1 bg-md-pink-light-2 px-3 pr-8 rounded-md transition-all duration-200", buttonClasses)}>
              {button ? (
                button
              ) : (
                <>
                  {buttonIconPosition === "left" && <i className={classNames("fa-fw", buttonIcon)}></i>}
                  {buttonLabel && <div className={classNames("text-base font-medium block !leading-none", buttonLabelClasses)}>{buttonLabel}</div>}
                  {buttonIconPosition === "right" && <i className={classNames("fa-fw", buttonIcon)}></i>}
                  {buttonArrowIcon && (
                    <div className={classNames("absolute top-1/2 right-1 -translate-y-1/2", buttonArrowIconClasses)}>
                      <i className={classNames("fa-fw", buttonArrowIcon)}></i>
                    </div>
                  )}
                </>
              )}
            </MenuButton>
          </div>
        </div>
        {showTransition && (
          <Transition
            as={Fragment}
            className="z-40"
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
            beforeEnter={() => setPopperElement(popperElRef.current)}
            afterLeave={() => setPopperElement(null)}
            ref={popperElRef}
            style={styles.popper}
            {...attributes.popper}
          >
            <MenuItems className={classNames("absolute mt-1 w-56 origin-top-right rounded-lg bg-white border border-md-pink-light-1 shadow shadow-md-pink/20 focus:outline-none py-1", dropdownContainer)}>
              <div className="py-1">
                {data.length > 0 &&
                  data.map((item, i) => (
                    <React.Fragment key={item?._id || i}>
                      {item?.link ? (
                        <MenuItem>
                          {({ active }) => (
                            <Link to={item?.link} className={classNames("group flex w-full items-center text-left px-3 py-1.5 text-sm gap-2 transition-all duration-200", active ? "bg-md-pink text-white" : "text-md-dark hover:bg-md-pink hover:text-white", item?.class)}>
                              {item?.icon && <i className={classNames("fa-fw", item?.icon)}></i>}
                              <span>{item?.name}</span>
                            </Link>
                          )}
                        </MenuItem>
                      ) : (
                        <MenuItem>
                          {({ active }) => (
                            <button
                              type="button"
                              className={classNames("group flex w-full items-center text-left text-slate-600 px-3 py-1.5 text-sm gap-2 transition-all duration-200", active ? (item?.standout ? "bg-md-pink text-white" : "text-md-dark hover:bg-md-pink hover:text-white") : "", item?.class)}
                              onClick={item?.click && typeof item?.click === "function" ? item?.click : onChange}
                            >
                              {item?.icon && (
                                <span className="flex items-center justify-center">
                                  <i className={classNames("fa-fw", item?.icon)}></i>
                                </span>
                              )}
                              <span>{item?.name}</span>
                            </button>
                          )}
                        </MenuItem>
                      )}
                    </React.Fragment>
                  ))}
              </div>
            </MenuItems>
          </Transition>
        )}
      </Menu>
    </>
  );
};

export default Dropdown;
